module.exports = "/images/ilustracion2.svg?f9f83cb619158e840d782ccefddcee43";